"use client";

import React, { useRef } from "react";
import { ContainerProp, descriptionObject } from "../../../global";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";

type TextContainerProp = Omit<ContainerProp, "imageSrc" | "altText"> & {
    description: descriptionObject[];
};

gsap.registerPlugin(ScrollTrigger);

export default function TextContainer({
    serviceName,
    header,
    description,
    className,
}: TextContainerProp) {
    const containerRef = useRef(null);

    useGSAP(
        () => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top 75%",
                    toggleActions: "play none none reverse",
                    // markers: true
                },
            }).to(".textChild", { opacity: 1, stagger: 0.3, y: 0 }); // <-- automatically reverted
        },
        { scope: containerRef }
    );

    return (
        <div className={"text-center lg:px-20 " + className} ref={containerRef}>
            {serviceName && (
                <h6 className="textChild opacity-0 translate-y-5">
                    {serviceName}
                </h6>
            )}
            <h2 className="text-purple textChild opacity-0 translate-y-5">
                {header}
            </h2>
            {description.map((desc, index) => (
                <div key={index}>
                    <p className="textChild opacity-0 translate-y-8">
                        {desc.type === "paragraph" && (
                            <>
                                {desc.children.map((para, index) =>
                                    para.bold ? (
                                        <b key={index}>{para.text}</b>
                                    ) : (
                                        <span key={index}>{para.text}</span>
                                    )
                                )}
                            </>
                        )}
                    </p>
                </div>
            ))}
        </div>
    );
}
